import React from 'react'
import styles from './styles.css'
import {withRouter, Link} from 'react-router'
import PropTypes from 'prop-types'
import withOrganization from 'App/Decorators/withOrganization'

const links = [
  {title: 'Inicio', path: '/securitySatCustom'},
  {title: 'Agregar productos', path: '/add'},
  {title: 'Productos', path: '/allProducts'}
]

@withRouter
@withOrganization
export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node,
    organization: PropTypes.object
  }

  renderLinks() {
    return links.map((link, index) => {
      const isActive = this.props.router.location.pathname === link.path
      return (
        <div key={index} onClick={link.onClick} className={isActive ? 'active' : ''}>
          <Link to={link.path}>{link.title}</Link>
        </div>
      )
    })
  }

  render() {
    if (!this.props.organization || this.props.organization.slug !== 'securitysat') {
      console.log('Route /Custom/Lay');
      return this.props.router.push('/')
    }
    const organization = this.props.organization
    if (organization.slug !== 'securitysat') return
    return (
      <div className={styles.container}>
        <div className="tabs">{this.renderLinks()}</div>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Custom/Layout/index.js